import { useEffect, useState } from 'react';
import {
  GroupEntityTagsContext,
  GroupEntityTagsDispatchContext,
  GroupEntityTagsFetchContext,
  GroupEntityTagsLoadingContext,
  GroupEntityTagsUpdateContext,
} from './context';
import type { GroupTagsContextValue, GroupTagUpdateItem, GroupFileTagsProps } from './interfaces';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';

export default function GroupFileTagsContainer(props: GroupFileTagsProps) {
  const [state, dispatch] = useState<GroupTagsContextValue>(GroupFileTagsContainer.initialState);

  const apiClient = useChatApiClient();

  const query = useQuery({
    queryKey: ['get:group/tags/file', props.fileId],
    queryFn: () => {
      return apiClient.tags.getFileTags({ fileId: props.fileId });
    },
    placeholderData: keepPreviousData,
  });

  useEffect(() => {
    if (query.isSuccess && query.data?.tags) {
      dispatch(query.data.tags);
    }
  }, [query.data?.tags, query.isSuccess]);

  const { mutateAsync } = useMutation({
    mutationFn: (tags: GroupTagUpdateItem[]) => {
      return apiClient.tags.updateFileTags({
        fileId: props.fileId,
        tags,
      });
    },
    onSuccess: result => {
      query.refetch();
    },
  });

  return (
    <GroupEntityTagsContext.Provider value={state}>
      <GroupEntityTagsLoadingContext.Provider value={query.isLoading}>
        <GroupEntityTagsFetchContext.Provider value={query.refetch}>
          <GroupEntityTagsUpdateContext.Provider value={mutateAsync}>
            <GroupEntityTagsDispatchContext.Provider value={dispatch}>
              {props.children}
            </GroupEntityTagsDispatchContext.Provider>
          </GroupEntityTagsUpdateContext.Provider>
        </GroupEntityTagsFetchContext.Provider>
      </GroupEntityTagsLoadingContext.Provider>
    </GroupEntityTagsContext.Provider>
  );
}

const initial: GroupTagsContextValue = [];

GroupFileTagsContainer.initialState = initial;

export { GroupFileTagsContainer };